import axios from "axios";
import { decryptData } from "../utils/decrypt";
import errorAlert from "../views/errors/errorAlert";

const BASE_URL = process.env.REACT_APP_API_URL;

export async function getPrinters() {
  try {
    const response = await axios.get(`${BASE_URL}/printers/get-printers`);
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
}

export async function insertPrinter(data) {
  try {
    const response = await axios.post(`${BASE_URL}/printers/insert-printer`, data);
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
}

// Función para actualizar producto
export async function deletePrinter(id) {
  try{
    const response = await axios.post(`${BASE_URL}/printers/delete-printer/${id}`);
    return decryptData(response);
  }catch(error){
    errorAlert(error);
  } 
}
